export default __webpack_public_path__ + "static/media/music_shop.9903a3eb.svg";